export const DEFAULT_REVIEWS_OFFSET = 0;
export const DEFAULT_REVIEWS_LIMIT = 14;
